module.exports = __webpack_public_path__ + "static/img/credential4.ac9c1ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/credential/credential4.jpg
// module id = Zt1H
// module chunks = 1